import ButtonT from '@components/tailwind-components/Button/ButtonT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { URL_REGEX } from '../../../../../constants/regex';
import { useModal } from '../../../../../hooks/modal/useModal';
import { useWebclientActions } from '../../../../../hooks/settings/webclients/useWebclientActions';

export const AddWebclientWhitelistModal: React.FC = () => {
  const { addWhitelistedDomain } = useWebclientActions();
  const { t } = useTranslation();

  const { handleSubmit, control } = useForm<{ domain: string }>({
    shouldUseNativeValidation: true,
    defaultValues: {
      domain: '',
    },
  });

  const { hideModal } = useModal();

  const hideAndSubmit = ({ domain }: { domain: string }) => {
    addWhitelistedDomain(domain);
    hideModal();
  };

  const CLIENT_URL = 'https://conversed.ai';

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='domain'
              placeholder={CLIENT_URL}
              label={t('settings.webclient.domain.title')}
              id='domain'
              control={control}
              options={{
                required: t('settings.webclient.validation.domain'),
                pattern: {
                  value: URL_REGEX,
                  message: t('settings.webclient.validation.domain.pattern'),
                },
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.add')}
        </ButtonT>
      </div>
    </form>
  );
};

export default AddWebclientWhitelistModal;
